import { get, post, remove } from "../axiosConfig";
import { ApiKey, ApiKeyPayload } from "../../../types";

export const ApiKeysAPI = {
  async getKeys(): Promise<ApiKey[]> {
    const { data } = await get("/telegram-fast-views/api-keys");
    return data;
  },

  async addApiKey(payload: ApiKeyPayload): Promise<ApiKey> {
    const { data } = await post("/telegram-fast-views/api-keys", payload);
    return data.result;
  },

  async removeApiKey(id: number): Promise<ApiKey> {
    const { data } = await remove(`/telegram-fast-views/api-keys/${id}`);
    return data;
  },
};
